import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import AuthenticateUser from './components/Auth/AuthenticateUser';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import store from './lib/store'

ReactDOM.render(
  <Provider store={store}>
    <AuthenticateUser/>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
